'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('./../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumberComponent = function NumberComponent(_ref) {
  var number = _ref.number,
      label = _ref.label;
  return _react2.default.createElement(_semanticUiReact.Popup, {
    trigger: _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(number)
    ),
    content: (0, _formatting.commaFormatted)(number) + ' ' + label
  });
};

NumberComponent.propTypes = {
  number: _propTypes2.default.number.isRequired,
  label: _propTypes2.default.string.isRequired
};

exports.default = NumberComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/number/index.js
 ** module id = 2619
 ** module chunks = 0
 **/